import {
  Avatar,
  Grid,
  IconButton,
  ListItem,
  ListItemAvatar,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { cyan, red } from "@mui/material/colors";

import AddCircle from "@mui/icons-material/AddCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import Remove from "@mui/icons-material/Remove";
import SaveIcon from "@mui/icons-material/Save";
import { useEditCvPortfolioMutation } from "../../../lib/cvsSlice";

const Portfolio = ({ portfolio, cvId }) => {
  const [showEdit, setEdit] = useState(false);
  const [port, setPort] = useState([portfolio]);
  const [editCvPortfolio, { isError, error }] = useEditCvPortfolioMutation();
  const portfolioRegex = /^https:\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,}){1,}([\/\S]*)?$/;
  
  const handleEdit = (val) => {
    setEdit(val);
  };

  const handleChange = (event, index) => {
    const newPort = [...port];
    newPort[index] = event.target.value;
    setPort(newPort);
  };

  const handleAdd = () => {
    const newPort = [...port];
    newPort.push('');
    setPort(newPort);
  };

  const handleRemove = (index) => {
    const newPort = [...port];
    newPort.splice(index, 1);
    setPort(newPort);
    toast.success("Portfolio removed");
  };

  useEffect(() => {
    const data = localStorage.getItem(`portfolio_${cvId}`);
    if (data !== null) setPort(JSON.parse(data));
  }, []);

  useEffect(() => {
    localStorage.setItem(`portfolio_${cvId}`, JSON.stringify(port));
  }, [port]);

  const handleSavePortfolio = async () => {
    if (!portfolioRegex.test(port)) {
      toast.error('Invalid portfolio link. Please enter a valid HTTPS URL.');
      return;
    }
    
    const portfolioString = port.join(';');
    await editCvPortfolio({ cvId, portfolio: portfolioString }).unwrap();
    toast.success('Portfolio updated');

    if (isError) {
      toast.error(`Portfolio was not updated at the moment: ${error}`);
    }
    setEdit(false);
  };

  return (
    <>
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ marginTop: "20px", padding: "15px" }}>

            {!showEdit && (
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                  >
                    <Grid item xs={10}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        component="div"
                        sx={{ p: 0, pb: 0 }}
                      >
                        Portfolio
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton
                        aria-label="edit"
                        onClick={() => handleEdit(true)}
                      >
                        <EditIcon color="primary" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>

                {port?.map((link, index) => (
                  <Grid item xs={12} key={index}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: cyan[700] }}>
                          <LinkIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <Typography
                        variant="body1"
                        gutterBottom
                        component="div"
                        sx={{
                          textAlign: "justify",
                          textJustify: "inter-word",
                        }}
                      >
                        <a
                          href={link}
                          style={{
                            color: cyan[700],
                            textDecoration: "none",
                            display: "block",
                            padding: "8px",
                            wordBreak: "break-all",
                          }}
                        >
                          {link}
                        </a>
                      </Typography>
                    </ListItem>
                  </Grid>
                ))}
              </Grid>
            )}

            {showEdit && (
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={9}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        component="div"
                        sx={{ p: 2, pb: 0 }}
                      >
                        Portfolio
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Tooltip title="Add new portfolio">
                        <IconButton aria-label="add" onClick={handleAdd}>
                          <AddCircle sx={{ color: cyan[600] }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                      <Tooltip title="save portfolio">
                        <IconButton
                          aria-label="save"
                          onClick={() => handleSavePortfolio()}
                        >
                          <SaveIcon sx={{ color: cyan[600] }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={1}>
                      <Tooltip title="cancel">
                        <IconButton
                          aria-label="cancel"
                          onClick={() => handleEdit(false)}
                        >
                          <CancelIcon sx={{ color: red[400] }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                {port?.map((value, index) => (
                  <Grid item xs={12} key={index}>
                    <Grid container spacing={0} justifyContent="center" alignItems="center">
                      <Grid item xs={11}>
                        <TextField
                          id={`portfolio-${index}`}
                          value={value}
                          fullWidth
                          onChange={(event) => handleChange(event, index)}
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: 'white',
                              borderRadius: '5px',
                              padding: '10px',
                              border: '1px solid #e0e0e0',
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <Tooltip title="Remove portfolio link">
                          <IconButton aria-label="remove" onClick={() => handleRemove(index)}>
                            <Remove sx={{ color: red[400] }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default Portfolio;